import { useNavigate } from "react-router-dom";
import { MenuSectionDataType, useUIHelper } from "../../biz/hooks/ui/useUIHelper";
import { useTheme } from "../../biz/hooks/ui/useTheme";
import { Config } from "../../biz/data/Config";
import { useUser } from "../../biz/hooks/entities/useUser";
import { useOrganization } from "../../biz/hooks/entities/useOrganization";
import { useTranslation } from "react-i18next";

export const LeftMenu = () => {
    const ui = useUIHelper();
    const nav = useNavigate();


    const btn = {
        style: { width: "100%" },
        onClick: () => {
            ui.setAppUiSimple();
            nav(Config.routes.start);
        }
    }
    return (

        <div className={"leftmenu-sections"} >
            {ui.menuItems.map(n => (<MenbuItem key={n.name} n={n} />))}

            <hr />

            {/* <ThemeToggle /> */}

            <div style={{ textAlign: "center" }}>
                <button {...btn}>
                    Enkel app
                </button>
            </div>

            {/* Languages */}
            <hr />
            <LanguageItem />
            <hr />
            <OrganizationItem />
        </div>


    )
}

const MenbuItem = ({ n }: { n: MenuSectionDataType }) => {



    const nav = useNavigate();

    return (
        <div key={n.name} className="menu-section">
            <div className="menu-section-header">
                {n.name}
            </div>
            {n.items.map(i => (
                <div key={i.link} className="menu-item" onClick={() => nav(i.link)} >
                    {/* <Link to={i.link}> */}
                    <div>
                        -  {i.name}
                    </div>
                    {/* </Link> */}
                </div>
            ))}
        </div>


    )

}

const ThemeToggle = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    const onClick = () => {
        if (theme?.currentTheme === theme.themeNamesAvailable.default) {
            theme.setTheme("theme-dark");
        } else {
            theme.setTheme("theme-default");
        }
    }

    return (
        <div>
            <div style={{ textAlign: "center" }}>
                {t("leftmenu_theme")}
            </div>

            {/* Button */}
            <div onClick={onClick}
                style={{ cursor: "pointer", textAlign: "center" }}>

                {/* SVG */}
                {theme?.currentTheme === theme.themeNamesAvailable.default && (
                    <svg fill="#000000" width="25%" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 330 330">
                        <path id="XMLID_6_" d="M239.999,75H90c-49.626,0-90,40.374-90,90s40.374,90,90,90h149.999c49.626,0,90-40.374,90-90
S289.625,75,239.999,75z M30,165c0-33.084,26.916-60,60-60s60,26.916,60,60s-26.916,60-60,60S30,198.084,30,165z M239.999,225
h-82.98c14.281-15.935,22.98-36.969,22.98-60s-8.699-44.065-22.98-60h82.98c33.084,0,60,26.916,60,60S273.083,225,239.999,225z" fill="#e7e7e7" />
                    </svg>
                )}

                {/* SVG */}
                {theme?.currentTheme !== theme.themeNamesAvailable.default && (
                    <svg fill="#000000" width="25%" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 485 485">
                        <g>
                            <path d="M356.25,113.75h-227.5C57.757,113.75,0,171.507,0,242.5s57.757,128.75,128.75,128.75h227.5
c70.993,0,128.75-57.757,128.75-128.75S427.243,113.75,356.25,113.75z M356.25,341.25c-54.451,0-98.75-44.299-98.75-98.75
s44.299-98.75,98.75-98.75S455,188.049,455,242.5S410.701,341.25,356.25,341.25z" fill="#e7e7e7" />
                        </g>
                    </svg>

                )}
            </div>
        </div>
    )
}

const LanguageItem = () => {
    const { t } = useTranslation();

    return (
        <div>
            <div style={{ textAlign: "center" }}>
                {t("language")}
            </div>

            <div style={{ textAlign: "center" }}>
                <select
                    name="selectedLanguage"
                    id="selectedLanguage"
                    value={t("selectedLanguage")}
                // onChange={e => t("remove").setLanguage(e.target.value as LanguageType)}
                >
                    {/* {["sv"].map(l => (
                        <option key={l.id} value={l.id}>{l.name}</option>
                    ))} */}
                </select>
            </div>
        </div>
    )
}
const OrganizationItem = () => {
    const org = useOrganization();
    const user = useUser();
    const { t } = useTranslation();

    return (
        <div>
            <div>
                {t("organizationname")}
            </div>
            <div>
                Loaded: {org.hasOrganizationSelected ? "J" : "N"}
            </div>
            {/* <div>
                Org?: {user.isInOrganization ? "J" : "N"}
            </div> */}
        </div>
    )
}